itsoftApp.createModule("lazyLoading", ["windowResize", "windowScroll", "scrollTo"], function () {
    const module = this;
    window.lazyQueue = [];
    window.lazyInitQueue = function () {
        if (!window.lazyQueue.length) {
            return;
        }

        while (window.lazyQueue.length > 0) {
            // Взять первый элемент массива,
            // и вызвать его. Мы уже знаем, что это функция,
            // поэтому доп. проверка не требуется.
            window.lazyQueue.shift()();
        }
    }

    let checking = false;

    window.lazyFunctions = {
        slider: function (element) {
            let sliderSettingsKey = element.getAttribute("data-slider-settings"); // получаем data-атрибут
            const sliderSettingsObject = itsoftApp.modules.slidersSettings.getSettings(sliderSettingsKey); // получаем объект конфига

            if (sliderSettingsKey && sliderSettingsObject) {
                new itsoftApp.modules.slidersLibrary.callback(element, sliderSettingsObject);
            } else {
                new itsoftApp.modules.slidersLibrary.callback(element);
            }
        },

        tabs: function (element) {
            new itsoftApp.modules.toggleTabs.callback.init(element);
        },

        takeAnim: function (element) {
            itsoftApp.modules.takeAnim.init(element);
        },

        scrollTrigger: function (element) {
            itsoftApp.modules.scrollActions.callback(element, true, false);
        },

        accordion: function (element) {
            new itsoftApp.modules.accordion.callback(element);
        },

        loadItems: function (element) {
            itsoftApp.modules.loadItems.initLoad(element);
        },

        loadItemsWithFilters: function (element) {
            itsoftApp.modules.loadItemsWithFilters.initLoad(element);
        },

        uteka: function (element) {
            itsoftApp.modules.uteka.callback(element);
        },

        videoPopup: function (element) {
            itsoftApp.modules.videoPopup.init(element);
        },

        infoBox: function (element) {
            itsoftApp.modules.infoBox.init(element);
        },

        sequence: function (element) {
            const onDocumentScroll = function () {
                DEBUG && console.log(element.getBoundingClientRect().top, ' lement.getBoundingClientRect().top');
                if (element.getBoundingClientRect().top > 0) {
                    window.removeEventListener("scroll", onDocumentScroll);
                    LazyLoad.resetStatus(element);
                    window.llCallback.update();
                }
            }
            if (itsoftApp.libraries.scrollToPlugin.active || itsoftApp.state.hashActive) {
                lazyQueue.push(function () {
                    window.addEventListener("scroll", onDocumentScroll);
                })
            } else {
                itsoftApp.modules.sequence.callback(element, true, false);
            }
        },

        social: function (element) {
            itsoftApp.modules.social.init(element);
        },

        videoAutoplay: function (element) {
            itsoftApp.modules.videoAutoplay.init(element);
        }
    };

    window.lazyLoadedFunctions = {
        videoAutoplay: function (element) {
            itsoftApp.modules.videoAutoplay.init(element);
        }
    }

    function executeLazyFunction(element) {
        var lazyFunctionName = element.getAttribute("data-lazy-function");
        var lazyFunction = window.lazyFunctions[lazyFunctionName];
        if (!lazyFunction) return;
        lazyFunction(element);
    }

    function executeLazyLoadedFunction(element) {
        var lazyFunctionName = element.getAttribute("data-lazy-loaded-function");
        var lazyFunction = window.lazyLoadedFunctions[lazyFunctionName];
        if (!lazyFunction) return;
        lazyFunction(element);
    }

    const Lazy = function () {
        this.path = "/assets/scripts/vanilla-lazyload/lazyload.min.js";

        this.init();
    };

    Lazy.prototype.setSettings = function () {
        window.llEarlier = new LazyLoad({ // eslint-disable-line
            unobserve_entered: true, // eslint-disable-line
            elements_selector: ".lazyload-earlier", // eslint-disable-line
            class_loaded: "loaded", // eslint-disable-line,
            class_entered: "entered",
            thresholds: "-100% 0px" // eslint-disable-line,
        });

        window.ll = new LazyLoad({ // eslint-disable-line
            // unobserve_entered: true, // eslint-disable-line
            elements_selector: ".lazy, .lazyload", // eslint-disable-line
            class_loaded: "loaded", // eslint-disable-line,
            class_entered: "entered", // eslint-disable-line,
            cancel_on_exit: true
        });

        window.llCallRequestOptions = { // eslint-disable-line
            unobserve_entered: true, // eslint-disable-line
            class_loaded: "loaded", // eslint-disable-line,
            class_entered: "entered" // eslint-disable-line,
        }

        window.llCallRequest = new LazyLoad(window.modalOptions);

        window.llCallback = new LazyLoad({ // eslint-disable-line
            unobserve_entered: true, // eslint-disable-line
            elements_selector: ".lazy-script, .js-script", // eslint-disable-line
            class_entered: "js-script-entered", // eslint-disable-line,
            callback_enter: executeLazyFunction
        });

        new LazyLoad({ // eslint-disable-line
            unobserve_entered: true, // eslint-disable-line
            elements_selector: ".js-anim", // eslint-disable-line
            class_entered: "js-anim--show", // eslint-disable-line,
            thresholds: "-15% 0px"
        });

        window.llLoadedCallback = new LazyLoad({ // eslint-disable-line
            unobserve_entered: true, // eslint-disable-line
            elements_selector: ".lazy-with-cb, .lazyload-with-cb", // eslint-disable-line
            class_loaded: "loaded", // eslint-disable-line,
            class_entered: "entered", // eslint-disable-line,
            callback_loaded: executeLazyLoadedFunction
        });
    };

    Lazy.prototype.init = function () {
        itsoftApp.loadScript(this.path, this.setSettings);
    };

    new Lazy();
    module.callback = Lazy;
});
